<app-upload-pdf-preparing-document
  *ngIf="isLoading$ | async"
  [value]="uploadProgress$ | async"
  [fileName]="fileName"
  [fileSize]="fileSize"
  [processingState]="processingState$ | async"
>
</app-upload-pdf-preparing-document>
<app-pdf-preview-selector
  *ngIf="(isLoading$ | async) === false"
  [pageItems]="pageItems$ | async"
  (selectedIndicesSubmitted)="selectedIndicesSubmitted($event)"
  (cancelClicked)="cancelClicked()"
>
</app-pdf-preview-selector>
